import React from 'react';

interface FeatureCard {
  title: string;
  description: string;
  icon?: string;
}

const HowWeHelp: React.FC = () => {
  const features: FeatureCard[] = [
    {
      title: "Courses",
      description: "Learn due diligence, speculation strategies, and operational excellence, inspired by Rob’s decades of success"
    },
    {
      title: "Real-Time Insights",
      description: "Access market updates and expert analysis via videos and discussions"
    },
    {
      title: "Collaboration",
      description: "Connect with elite investors to share mining investment strategies. Founding members enjoy priority access to Rob’s expertise, ensuring you speculate with confidence"
    }
  ];

  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#F6F6F6] pt-20 pb-20">
      <div className="">
        {/* Header Section */}
        <div className="text-left mb-16">
          <h2 className="text-[30px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7">
          How We Help You Find the Best Mining Stocks
          </h2>
          <p className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0 ">
          Join <a href="https://the-wealthy-miner.mn.co/" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#0B6054] transition-colors duration-300"><strong>The Wealthy Miner's Mighty Networks community</strong></a> and gain access to tools designed to uncover the best mining companies to invest in:          </p>
        </div>

        {/* Features Grid - All Screen Sizes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-[10px] p-6 sm:p-8 flex flex-col justify-start items-center text-center"
            >
              <div className="mb-3 flex flex-col items-center">
                <div className="w-16 h-16 flex items-center justify-center mb-4">
                  {index === 0 ? (
                    <img 
                      src="/images/Courses.webp" 
                      alt="Stock icon" 
                      className="w-10 h-10 object-contain"
                    />
                  ) : index === 1 ? (
                    <img 
                      src="/images/insights.webp" 
                      alt="Time icon" 
                      className="w-10 h-10 object-contain"
                    />
                  ) : index === 2 ? (
                    <img 
                      src="/images/collaboration.webp" 
                      alt="Deep analysis icon" 
                      className="w-10 h-10 object-contain"
                    />
                  ) : (
                    <span className="text-white text-2xl font-bold">
                      {index + 1}
                    </span>
                  )}
                </div>
                <h3 className="text-[26px] font-[600] text-[#000] text-center">
                  {feature.title}
                </h3>
              </div>
              <p className="text-[18px] text-[#000] leading-[1.6] text-center">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-16 text-[14px] lg:text-[18px] md:text-[15px]">
          <a href="https://the-wealthy-miner.mn.co/" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto bg-[#0B6054] text-white lg:px-10 py-3.5 rounded-[10px] font-semibold hover:bg-[#1A2A44] transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#1A2A44] focus:ring-opacity-50 text-center">
            JOIN A TRIBE OF WINNING SPECULATORS
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowWeHelp;
